import { render, staticRenderFns } from "./SelectStatusOrder.vue?vue&type=template&id=75ef1b1e&scoped=true&"
import script from "./SelectStatusOrder.vue?vue&type=script&lang=js&"
export * from "./SelectStatusOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ef1b1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
